// Loading Spinner component - 24 lines ✅
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  className?: string
  message?: string
}

export function LoadingSpinner({ className, message }: LoadingSpinnerProps): JSX.Element {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2', className)}>
      <Loader2 className="h-8 w-8 animate-spin text-kaycoo-teal-dark" aria-hidden="true" />
      {message && (
        <p className="text-sm text-kaycoo-charcoal-2">
          {message}
        </p>
      )}
      <span className="sr-only">Loading...</span>
    </div>
  )
}
